/**
 * Frontend Configuration File for MK MOTORS CRM
 * 
 * To update the backend API link/URL in Production Build:
 * Option 1: Edit `build/config.js` directly in your production build folder!
 *           Set window.ENV.REACT_APP_API_BASE_URL = "https://rto.synicate.online"
 * Option 2: Set REACT_APP_API_BASE_URL in your .env file before building.
 */

export const API_BASE_URL =
  (typeof window !== "undefined" && window.ENV && window.ENV.REACT_APP_API_BASE_URL) ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://rto.synicate.online";

const config = {
  API_BASE_URL,
};

export default config;
